module.exports = __webpack_public_path__ + "img/primary_11x2_z16.f0ec3a15.svg";